export default __webpack_public_path__ + "static/media/html-5.ff3cf75e.png";